import BaseApi from './BaseApi'

class NavigationLinksApi extends BaseApi {

  get navigationLinksUrl () {
    return 'navigationLinks'
  }

  getNavigationLinks () {
    return this.getJson(this.navigationLinksUrl)
  }
}
export default NavigationLinksApi
